import { PropsWithChildren, useMemo } from 'react';
import ReactRating, { RatingComponentProps } from 'react-rating';
import { Box, FelaCSS, TColor } from '@bridebook/ui';
import componentStyles from '@bridebook/ui/src/components/bbcommon/rating/rating.style';
import { IconClass } from '@bridebook/ui/src/icons/constants';

interface IProps extends PropsWithChildren {
  rating: number;
  onChange?: RatingComponentProps['onChange'];
  readonly?: boolean;
  width?: number;
  large?: boolean;
  style?: FelaCSS;
  overrideColor?: TColor;
  starGap?: number;
}

const Rating = ({
  rating,
  onChange,
  readonly = true,
  width,
  children,
  style = {},
  overrideColor,
  starGap = 2,
}: IProps) => {
  const styles = componentStyles({ width, starGap });

  const emptySymbolStyles = useMemo(
    () => styles.reviewIcon(overrideColor),
    [overrideColor, styles],
  );
  const fullSymbolStyles = useMemo(
    () => styles.reviewFilledIcon(overrideColor),
    [overrideColor, styles],
  );

  return (
    <Box style={Object.assign(styles.wrapper, style)} data-name="rating">
      {/* @ts-expect-error Issue with internal types of react */}
      <ReactRating
        emptySymbol={<span className={IconClass.Review} style={emptySymbolStyles} />}
        fullSymbol={<span className={IconClass.ReviewFilled} style={fullSymbolStyles} />}
        initialRating={rating}
        readonly={readonly}
        onChange={onChange}
      />
      {children}
    </Box>
  );
};

export default Rating;
